import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { TOAST_ERROR_DEFAULT_OPTIONS } from '../../../constants/toast'
import { useExpertPersonTypeMutation } from '../../../services/hooks/experts/mutations/useExpertPersonTypeMutation'
import { getErrorMessage } from '../../../utils/getErrorMessage'
import { type PersonType } from '../../../enumns/personType'
import { type ExpertDomain } from '../../../types/domain/expert-domain'

export const usePersonalData = (expert?: ExpertDomain) => {
  const { mutate, isLoading: isChangingPersonType } = useExpertPersonTypeMutation()

  const navigate = useNavigate()

  const [isPersonTypeChangeAlertVisible, setIsPersonTypeChangeAlertVisible] =
    useState(false)
  const [selectedPersonType, setSelectedPersonType] = useState<
    `${PersonType}` | null
  >(null)

  const handleChangePersonType = () => {
    mutate(
      { id: expert!.id, personType: selectedPersonType as any },
      {
        onSuccess () {
          setIsPersonTypeChangeAlertVisible(false)
          navigate('/expert/personal-data/stepper')
        },
        onError (error: unknown) {
          toast.error(getErrorMessage(error), TOAST_ERROR_DEFAULT_OPTIONS)
        },
      }
    )
  }

  const handleOpenPersonTypeChangeAlert = (
    selectedPersonType: `${PersonType}`
  ) => {
    setSelectedPersonType(selectedPersonType)
    setIsPersonTypeChangeAlertVisible(true)
  }

  return {
    isChangingPersonType,
    selectedPersonType,
    isPersonTypeChangeAlertVisible,
    setIsPersonTypeChangeAlertVisible,
    handleChangePersonType,
    handleOpenPersonTypeChangeAlert
  }
}
